import React, {Component} from "react";
import {useHistory} from "react-router";
import logo from "./logo.svg";
import Button from "reactstrap/es/Button";
import './App.css';
import Alert from "reactstrap/es/Alert";
import rest from "./restService";


class MyHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alertColor: 0,
            alertVisible: false,
            alertText: '',
            closeDisabled: false,
        }

        this.rest = new rest();
    }

    closeKasa() {
        let allChecks = JSON.parse(localStorage.getItem("allChecks"));
        if (allChecks.length === 0) {
            this.showAlert('info', 'Немає даних для збереження.');
            return
        }
        this.setState({
            closeDisabled: true
        });
        this.rest.saveCheck(allChecks, (res) => {
           if (res === '"ok"') {
               this.showAlert('success', "Зміну успішно закрито");
               localStorage.setItem('allChecks', JSON.stringify([]));
           } else this.showAlert('danger', 'Помилка при передачі чеків');
           this.setState({
               closeDisabled: false
           })
        }, (error) => {
            this.showAlert('danger', 'Помилка при передачі чеків');
            console.log(error);
            this.setState({
                closeDisabled: false
            })
        });

    };

    alertDismiss() {
        this.setState({
            alertVisible: false
        })
    };

    showAlert(color, text) {
        this.setState({
            alertColor: color,
            alertText: text,
            alertVisible: true,
        });
    };


    render() {
        return (
            <div>
                <Button color={"warning"}
                        disabled={this.state.closeDisabled}
                        onClick={() => {
                            this.closeKasa();
                        }}
                >Закрити зміну</Button>
                <br/>
                < Alert
                    className="alert"
                    color={this.state.alertColor}
                    isOpen={this.state.alertVisible}
                    toggle={() => this.alertDismiss()
                    }>
                    {
                        this.state.alertText
                    }
                </Alert>
            </div>
        //let history = useHistory();
)
    }
}


function Home() {
    let history = useHistory();

    if (!localStorage.getItem("access-token")) {
        history.push("/auth");
    }


    return (
        <div>
            <div className="App">

                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo"/>
                    <p className="title">
                        Лише для внутрішнього використання мереж Пінгвін, Лечо, VAM
                    </p>

                    <Button color={"info"}
                            onClick={() => {
                                history.push('tsd');
                            }}
                    >Збір даних</Button>
                    <br/>
                    <Button color={"danger"}
                            onClick={() => {
                                history.push('retail');
                            }}
                    >Каса</Button>
                    <br/>
                    <MyHome/>
                    <br/>
                </header>
            </div>
        </div>
    );

}

export default Home;
